import { TabProxy } from "encampy";

export async function automateAZmyDEQLogin(
  tab: TabProxy,
  username: string,
  password: string
): Promise<void> {
  // Wait for the login page to load
  await tab.waitForElement("input[name='identifier']", { timeout: 10000 });

  // Type in the username
  await tab.type("input[name='identifier']", username);

  // Click Next (no navigation happens here)
  await tab.click("input[type='submit'][value='Next']");

  // Type in the password
  await tab.type("input[type='password'][name='credentials.passcode']", password);

  // Click Log In
  await tab.click("input[type='submit'][value='LOG IN']");

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });
}
